/* global BUGSNAG_API_KEY APP_VERSION */
import bugsnag from 'bugsnag-js';

const bugsnagClient = BUGSNAG_API_KEY ? bugsnag({
  apiKey: BUGSNAG_API_KEY,
  appVersion: APP_VERSION
}) : null;

export default bugsnagClient;
